import React, {useState, useEffect} from 'react';
import { PiLockKeyLight} from "react-icons/pi";
import {FormValidator,useFormValidator,Inputs} from 'coaz-ui';
import client from '../client';

const ResetPassword = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const [autoPassword, setAutoPassword] = useState(true);
    const [newPassword, setNewPassword] = useState(''); 
    const [confirmPassword, setConfirmPassword] = useState(''); 
    const {request,errorMessage} = client;

    const minWidth = 240;

    const submit = async (e) => {
        if(!params || !params.username) {
            return {
                message:"No username"
            }
        }
        if(newPassword !== confirmPassword) {
            return {
                message:"New password and confirm password didn't match, try again!"
            }
        }
        try {
            const response = await request('PUT','users/reset-password',null,
            {
                username:params.username,
                autoPassword:autoPassword,
                newPassword:newPassword
            });

            if (response) {
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const inputs = [
        {
            label:"Username",
            type:"text", 
            id:"username", 
            name:"username",  
            value:params.username?params.username:'',
            placeholder:"Enter username...",
            disabled:true
        },
        {
            label:"Auto password",
            type:'checkbox', 
            name:"autoPassword",  
            value:autoPassword,
            onChange:(e) => {
                setAutoPassword(!autoPassword)
            }
        },
        { 
            label:"New Password",
            type:"password",
            id:"newPassword", 
            name:"newPassword",  
            value:newPassword,
            placeholder:"Enter new password...",
            onChange:(e) => handleChange(e,(e) => {
                setNewPassword(e.target.value);
            }),
            disabled:autoPassword,
            register:register,
            checks:['empty'],
            errors:errors
        },
        { 
            label:"Confirm Password",
            type:"password",
            id:"confirmPassword", 
            name:"confirmPassword",  
            value:confirmPassword,
            placeholder:"Confirm password...",
            onChange:(e) => handleChange(e,(e) => {
                setConfirmPassword(e.target.value);
            }),
            disabled:autoPassword,
            register:register,
            checks:['empty'],
            errors:errors
        }
    ]

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        setLoading && setLoading(false);
    },[])

    return (
        <FormValidator>
            <div className='flex flex-col w-full h-auto'>
                <div className='flex flex-col w-full h-full no-scrollbar space-y-8 overflow-auto'>
                    <PiLockKeyLight size={64} className='flex mx-auto mb-4 text-theme shrink-0'/>
                    <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
                </div>
            </div>
        </FormValidator>
    )
}

export default ResetPassword
